<template>
  <div class="md-layout md-gutter md-alignment-center">
    <div class="md-layout-item md-size-100">
      <md-card-content>
        <div class="form-horizontal">
          <md-field class="field-item">
            <label>Número de Vuelo</label>
            <md-input v-model="vuelo.numero_vuelo" />
          </md-field>

          <md-field>
            <label>Fecha</label>
            <md-input type="date" v-model="vuelo.fecha" :max="usuario.rol !== 'admin' ? hoy : null"
              :min="usuario.rol !== 'admin' ? fechaMinima : null" />
          </md-field>

          <md-field class="field-item">
            <label>Número de Constancia</label>
            <md-input v-model="vuelo.numero_constancia" />
          </md-field>

          <md-field class="field-item">
            <label>Regional</label>
            <div class="custom-select-wrapper">
              <select v-model="vuelo.regional_id" class="custom-select" :disabled="usuario.rol !== 'admin'" required>
                <option value="" disabled>Seleccione Regional</option>
                <option v-for="regional in regionales" :key="regional.id" :value="regional.id">
                  {{ regional.nombre }}
                </option>
              </select>
            </div>
            <span class="md-error" v-if="!vuelo.regional_id">Regional es requerida</span>
          </md-field>

        </div>
        <div class="alerta-roja">Servicio en Ruta Nacional: Ingrese el valor total del servicio</div>
        <div v-for="(servicios, categoria) in serviciosPorCategoria" :key="categoria" class="categoria-group">
          <h3>{{ categoria }}</h3>

          <div v-for="servicio in servicios" :key="servicio.id" class="servicio-horizontal">
            <div class="servicio-nombre">
              {{ servicio.nombre }} ({{ servicio.valor_unitario }} $)
            </div>

            <md-field class="field-small">
              <label>Constancias</label>
              <md-input type="number" min="0" v-model.number="servicio.constancias" />
            </md-field>

            <md-field class="field-medium">
              <label>Observaciones</label>
              <md-input v-model="servicio.observaciones" />
            </md-field>
          </div>
        </div>
      </md-card-content>

      <div class="button-wrapper">
        <md-button class="md-raised md-primary" @click="registrarVuelo">
          Registrar vuelo y servicios
        </md-button>
      </div>

      <p v-if="mensaje" :class="{ error: error, success: !error }">
        {{ mensaje }}
      </p>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  data() {
    const hoy = new Date();
    const ayer = new Date();
    ayer.setDate(hoy.getDate() - 1);

    const toYMD = (date) => date.toISOString().slice(0, 10);

    // Obtener el usuario del localStorage
    let usuario = {};
    try {
      usuario = JSON.parse(localStorage.getItem("usuario")) || {};
    } catch (e) {
      usuario = {};
    }

    return {
      hoy: toYMD(hoy),
      ayer: toYMD(ayer),
      usuario, // ✅ AÑADIDO AQUÍ
      vuelo: {
        numero_vuelo: '',
        fecha: toYMD(hoy),
        numero_constancia: '',
        regional_id: usuario.rol !== 'admin' ? usuario.regional_id : null, // Preasignado si no es admin
      },
      regionales: [],
      serviciosPorCategoria: {},
      mensaje: '',
      error: false,
    };
  },
  methods: {
    async obtenerRegionales() {
      const token = localStorage.getItem("authToken");

      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/usuario_regional.php', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const text = await res.text();

        //console.log('Respuesta cruda:', text);

        // Intenta convertir a JSON
        this.regionales = JSON.parse(text);
      } catch (e) {
        //console.error('Error al obtener regionales:', e);
        this.mensaje = 'Error al cargar las regionales.';
        this.error = true;
      }
    },


    async obtenerServicios() {
      const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/services/servicios_agrupados.php');
      const data = await res.json();
      this.serviciosPorCategoria = data;
    },

    async registrarVuelo() {
      if (!this.vuelo.numero_vuelo || !this.vuelo.fecha || !this.vuelo.numero_constancia || !this.vuelo.regional_id) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Por favor complete todos los campos del vuelo.'
        });
        return;
      }

      const fechaIngresada = new Date(this.vuelo.fecha);
      const fechaMin = new Date(this.fechaMinima);
      const fechaMax = new Date(this.hoy);

      if (this.usuario.rol !== 'admin') {
        if (isNaN(fechaIngresada) || fechaIngresada < fechaMin || fechaIngresada > fechaMax) {
          Swal.fire({
            icon: 'warning',
            title: 'Fecha inválida',
            text: `La fecha debe estar entre ${this.fechaMinima} y ${this.hoy}.`
          });
          return;
        }
      }
      const servicios = [];
      Object.values(this.serviciosPorCategoria).forEach(serviciosGrupo => {
        serviciosGrupo.forEach(servicio => {
          if (servicio.constancias > 0) {
            servicios.push({
              servicio_id: servicio.id,
              constancias: servicio.constancias,
              observaciones: servicio.observaciones || '',
            });
          }
        });
      });

      const payload = {
        vuelo: this.vuelo,
        servicios,
      };

      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/vuelo/registrar_vuelo_servicios.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const result = await res.json();

        if (result.error) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: result.message || 'No se pudo registrar el vuelo.'
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Vuelo registrado',
            text: result.message || 'Registro exitoso.',
            timer: 2000,
            showConfirmButton: false
          });
          this.resetearFormulario();
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error de red',
          text: 'No se pudo conectar al servidor.'
        });
      }
    },


    resetearFormulario() {
      this.$nextTick(() => {
        this.vuelo = {
          numero_vuelo: '',
          fecha: this.hoy,
          numero_constancia: '',
          regional_id: this.usuario.rol !== 'admin' ? this.usuario.regional_id : null,
        };

        Object.values(this.serviciosPorCategoria).forEach(serviciosGrupo => {
          serviciosGrupo.forEach(servicio => {
            servicio.constancias = 0;
            servicio.observaciones = '';
          });
        });
      });
    },
  },
  computed: {
    fechaMinima() {
      // Busca la regional seleccionada
      const regional = this.regionales.find(r => r.id == this.vuelo.regional_id);
      // Si es Santa Cruz, permite 72 horas (3 días)
      if (regional && regional.nombre && regional.nombre.toLowerCase().includes('santa cruz')) {
        const fecha = new Date(this.hoy);
        fecha.setDate(fecha.getDate() - 2); // 3 días incluyendo hoy
        return fecha.toISOString().slice(0, 10);
      }
      // Para otras regionales, 48 horas (2 días)
      return this.ayer;
    }
  },

  mounted() {
    this.obtenerRegionales();
    this.obtenerServicios();
  }
};
</script>


<style>
.alerta-roja {
  color: #d32f2f;
  font-weight: bold;
  margin: 10px 0 15px 0;
  font-size: 1.05rem;
}

.form-container {
  padding: 10px;
  max-width: 1100px;
  margin: auto;
}

.form-horizontal {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

@media (max-width: 600px) {
  .form-horizontal {
    flex-direction: column;
  }

  .field-item {
    width: 100%;
    min-width: unset;
  }
}

.categoria-group {
  margin-bottom: 10px;
  background: #f9f9f9;
}

.servicio-horizontal {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  flex-wrap: wrap;
}

.servicio-nombre {
  flex: 0 0 270px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.field-small {
  flex: 1;
  min-width: 150px;
}

.field-medium {
  flex: 1;
  min-width: 150px;
}

.button-wrapper {
  margin-top: 20px;
}

.error {
  color: red;
}

.success {
  color: green;
}

.md-field {
  margin: 8px 0;
  min-height: 48px;
}

h3 {
  margin: 0 0 8px 0;
  font-size: 1rem;
}

.custom-select-wrapper {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  background-color: #fff;
  padding: 6px 12px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.custom-select-wrapper:focus-within {
  border-color: #3f51b5;
  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
}

.custom-select {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  appearance: none;
}

.custom-select-wrapper::after {
  content: '▾';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.54);
  pointer-events: none;
}
</style>
